import {
    ViewFactory,
    ComponentManager,
} from 'radpresentation.htmlclient.defaultviewextensions';
import CreateDynamicAssociationViewViewModel from '@/ViewModels/Views/CreateDynamicAssociationViewViewModel';
import CreateDynamicAssociationView from '@/Views/CreateDynamicAssociationView';
class CreateDynamicAssociationViewFactory extends ViewFactory {
    public viewModel: CreateDynamicAssociationViewViewModel;
    public view: CreateDynamicAssociationView;

    constructor(private params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Modal';
    }

    public getView(): JQuery<HTMLElement> {
        if (!this.viewModel) {
            this.viewModel = new CreateDynamicAssociationViewViewModel({
                callback: this.params.callback,
                metaData: this.params.metaData,
                locator: this.params.locator,
                viewFactory: this,
            });
        }

        if (!this.view) {
            this.view = new CreateDynamicAssociationView(
                this.viewModel,
                this.createRootElement('CreateDynamicAssociationView')
            );
        }

        return this.view.getTuple().view;
    }
}

export default CreateDynamicAssociationViewFactory;
ComponentManager.setFactory(
    'CreateDynamicAssociation',
    CreateDynamicAssociationViewFactory,
    'RADExtensionManagerHTMLViewExtension'
);
